import React from "react"
import { Common } from "lib/types"
import { ReactComponent as StoreIcon } from "images/icons/store.svg"
import { ReactComponent as InventoryIcon } from "images/icons/warehouse.svg"
import { ReactComponent as TaxIcon } from "images/icons/badge-percent.svg"
import { PermissionGroups } from "../constants"

import { Stores } from "views/Stores/Stores"
import { StoreGroups } from "views/Stores/StoreGroups/StoreGroups"
import { Inventories } from "views/Inventories/Inventories"
import { Taxes } from "views/Taxes/Taxes"

export const storeRoutes: Common.Views = [
  {
    element: <Stores />,
    path: "/stores",
    title: "Stores",
    icon: StoreIcon,
    sortOrder: 6,
    requiredGroups: PermissionGroups.stores.read,
    children: [
      {
        element: <StoreGroups />,
        path: "/stores/store-groups",
        title: "Store groups",
        icon: StoreIcon,
        parentPath: "/stores",
        section: "Store group"
      },
      {
        element: <Inventories />,
        path: "/stores/inventories",
        title: "Inventories",
        icon: InventoryIcon,
        parentPath: "/stores",
        requiredGroups: PermissionGroups.inventories.read,
        section: "Inventory"
      },
      {
        element: <Taxes />,
        path: "/stores/taxes",
        title: "Tax groups",
        icon: TaxIcon,
        section: "Tax groups",
        requiredGroups: PermissionGroups.tax.read
      }
    ]
  }
]
